import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { Plus, Download, Award } from 'lucide-react';

export default function CertificatesPage() {
  const [data, setData] = useState({ stats: {}, recent: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/certificates/dashboard/stats').then(res => setData(res.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div>טוען...</div>;

  return (
    <div>
      <div className="page-header" style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
        <div>
          <h1>אישורים</h1>
          <p>כל האישורים שהופקו</p>
        </div>
        <Link to="/certificates/new" className="btn btn-primary">
          <Plus size={18} /> אישור חדש
        </Link>
      </div>

      <div className="card">
        {data.recent.length === 0 ? (
          <div style={{textAlign:'center', padding:'40px 0'}}>
            <Award size={48} color="var(--border)" style={{margin:'0 auto 16px'}} />
            <p style={{color:'var(--text-muted)'}}>אין אישורים עדיין</p>
          </div>
        ) : (
          <table style={{width:'100%', borderCollapse:'collapse'}}>
            <thead>
              <tr style={{borderBottom:'2px solid var(--border)'}}>
                <th style={{textAlign:'right', padding:'10px 12px', fontSize:12, color:'var(--text-muted)', fontWeight:600}}>שם</th>
                <th style={{textAlign:'right', padding:'10px 12px', fontSize:12, color:'var(--text-muted)', fontWeight:600}}>מייל</th>
                <th style={{textAlign:'right', padding:'10px 12px', fontSize:12, color:'var(--text-muted)', fontWeight:600}}>תבנית</th>
                <th style={{textAlign:'right', padding:'10px 12px', fontSize:12, color:'var(--text-muted)', fontWeight:600}}>תאריך</th>
                <th style={{textAlign:'right', padding:'10px 12px', fontSize:12, color:'var(--text-muted)', fontWeight:600}}>הורדות</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.recent.map(cert => (
                <tr key={cert.id} style={{borderBottom:'1px solid var(--border)'}}>
                  <td style={{padding:'12px', fontSize:14, fontWeight:500}}>{cert.requester_name || '—'}</td>
                  <td style={{padding:'12px', fontSize:13, color:'var(--text-muted)'}}>{cert.requester_email || '—'}</td>
                  <td style={{padding:'12px', fontSize:13, color:'var(--text-muted)'}}>{cert.template_name || '—'}</td>
                  <td style={{padding:'12px', fontSize:13, color:'var(--text-muted)'}}>{new Date(cert.created_at).toLocaleDateString('he-IL')}</td>
                  <td style={{padding:'12px'}}>
                    <span className="badge badge-info">{cert.download_count} הורדות</span>
                  </td>
                  <td style={{padding:'12px'}}>
                    <a
                      href={`/api/certificates/${cert.id}/download`}
                      className="btn btn-secondary"
                      style={{padding:'6px 12px', fontSize:12}}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Download size={14} /> הורדה
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
